import { createSelector } from 'reselect';
import { get as _get } from 'lodash';

import {
    selectItemForUpdateFactory,
    selectListPendingFactory,
    selectDetailPendingFactory,
    selectItemPendingFactory,
    selectFirestore,
} from 'services/selectors';

import { defaultInfoValues, defaultInfoCategoryValues } from './config';

const selectInfoState = state => state.info;

const selectPending = createSelector(selectInfoState, info => info.pending);

const selectInfoPending = createSelector(selectPending, pending => pending.info);

const selectInfoCategoriesPending = createSelector(selectPending, pending => pending.infoCategories);

export const selectInfoListPending = selectItemPendingFactory(selectInfoPending);
export const selectInfoDetailPending = selectDetailPendingFactory(selectInfoPending);
export const selectInfoItemPending = selectItemPendingFactory(selectInfoPending);

export const selectInfoCategoriesListPending = selectListPendingFactory(selectInfoCategoriesPending);
export const selectInfoCategoriesDetailPending = selectDetailPendingFactory(selectInfoCategoriesPending);
export const selectInfoCategoriesItemPending = selectItemPendingFactory(selectInfoCategoriesPending);

export const selectInfoCategories = createSelector(selectFirestore, firestore =>
    _get(firestore, 'ordered.infoCategories', []),
);

export const selectInfo = createSelector(
    selectFirestore,
    (_, categoryId) => categoryId,
    (firestore, categoryId) =>
        _get(firestore, `ordered.info<${categoryId}>`, []).map(info => ({ ...info, categoryId })),
);

export const selectInfoCategoryForUpdate = selectItemForUpdateFactory('infoCategory', defaultInfoCategoryValues);
export const selectInfoForUpdate = selectItemForUpdateFactory('info', defaultInfoValues);
